import React, { useEffect, useState, useRef } from 'react';
import './index.scss';

interface TdsOverlayProps {
  component: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  overlayClassName?: string;
  trigger?: 'hover' | 'click';
  placement?: 'top' | 'left' | 'bottom' | 'right' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
  fixed?: boolean;
  onVisibleChange?: (visible: boolean) => void;
  timeout?: number;
}

let timeoutId: number;

export const TdsOverlay: React.FC<TdsOverlayProps> = ({
  component,
  children,
  className = '',
  overlayClassName = '',
  trigger = 'hover',
  placement = 'bottom',
  fixed,
  onVisibleChange,
  timeout = 0,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const overlayRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    window.clearTimeout(timeoutId);
    if (trigger === 'hover') {
      setShouldRender(true);
      window.setTimeout(() => setIsVisible(true), 10); // 小延迟确保CSS过渡生效
    }
  };

  const handleMouseLeave = () => {
    timeoutId = window.setTimeout(() => {
      if (trigger === 'hover') {
        setIsVisible(false);
      }
    }, timeout);
  };

  const handleClick = () => {
    if (trigger === 'click') {
      if (!isVisible) {
        setShouldRender(true);
        window.setTimeout(() => setIsVisible(true), 10);
      } else {
        setIsVisible(false);
      }
    }
  };

  // 处理动画结束事件
  const handleTransitionEnd = () => {
    if (!isVisible) {
      setShouldRender(false);
    }
  };

  useEffect(() => {
    if (onVisibleChange) onVisibleChange(isVisible);
  }, [isVisible]);

  useEffect(() => {
    const overlayElement = overlayRef.current;
    if (overlayElement) {
      overlayElement.addEventListener('transitionend', handleTransitionEnd);
    }

    return () => {
      if (overlayElement) {
        overlayElement.removeEventListener('transitionend', handleTransitionEnd);
      }
    };
  }, [isVisible]);

  return (
    <div
      className={`tds-overlay-container ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {children}
      <div
        ref={overlayRef}
        className={`tds-overlay-content ${isVisible ? 'fade-in' : 'fade-out'} ${fixed ? 'fixed' : `placement-${placement}`} ${overlayClassName}`}
        style={{ display: shouldRender ? 'block' : 'none' }}
      >
        {component}
      </div>
    </div>
  );
};
